import { render, staticRenderFns } from "./ListMain.vue?vue&type=template&id=371bd85e&scoped=true&"
import script from "./ListMain.vue?vue&type=script&lang=js&"
export * from "./ListMain.vue?vue&type=script&lang=js&"
import style0 from "./ListMain.vue?vue&type=style&index=0&id=371bd85e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371bd85e",
  null
  
)

export default component.exports